import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, getContrastColor } from '@reveni-io/reveni-ui'

import GroupChipLabel from './GroupChipLabel/GroupChipLabel'
import * as Styles from './styles'

const GroupChips = ({ groups, isOwner }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (isOwner) {
    return (
      <Styles.Container>
        <Chip
          label={t('Propietario')}
          backgroundColor={theme.colors.outline.default}
          color={getContrastColor(theme.colors.outline.default, theme)}
        />
      </Styles.Container>
    )
  }

  return (
    <Styles.Container>
      {groups?.map(group => {
        const backgroundColor = group.color || theme.colors.border.subtle

        return (
          <Chip
            key={group.name}
            label={<GroupChipLabel group={group} />}
            backgroundColor={backgroundColor}
            color={getContrastColor(backgroundColor, theme)}
          />
        )
      })}
    </Styles.Container>
  )
}

export default GroupChips
